import Button from '../../../reusable/button/button.component';

import sectionDisplayMap from './index';

import {
  ContentContainer,
  MainContainer,
  Text,
  Title
} from '../../../../styles/component.styles';

const SectionDisplay = ({ section, getSection, setShowUpdate }) => {
  const SectionRenderer = sectionDisplayMap[section.type] || null;

  return (
    <MainContainer>
      <ContentContainer>
        <Title>Section: {section.type}</Title>
        <Text>Position: {section.position}</Text>

        {SectionRenderer ? (
          <SectionRenderer section={section} getSection={getSection} />
        ) : (
          <Text>Unsupported section type</Text>
        )}

        <Button onClick={() => setShowUpdate(true)}>Update Section</Button>
      </ContentContainer>
    </MainContainer>
  );
};

export default SectionDisplay;